import styled from '@emotion/styled';

const primary = '#fec823';
const formBg = 'rgb(249, 249, 249)';

const SubmitButton = styled.button`
  display: block;
  height: 40px;
  width: 190px;
  font-size: inherit;
  background-color: ${props => (props.disabled ? '#710706' : "#9e0201")};
  box-shadow: ${props =>
    props.disabled
      ? "none"
      : "0 6px 9px rgba(50, 50, 93, 0.06), 0 2px 5px rgba(0, 0, 0, 0.08), inset 0 1px 0 #ffb9f6;"};
  border-radius: 24px;
  opacity: ${props => (props.disabled ? 0.7 : 1)};
  color: #fff;
  font-weight: 600;
  cursor: pointer;
`;

export default SubmitButton;
